<template>
<!-- eslint-disable -->
  <div
    :style="[sizeStyle, clampStyle]"
    class="vtextbox cursor-help"
    :title="text">
    <template v-if="maxChars && text && text.length >= maxChars"
      >{{ truncateText(text) }}</template><!-- pre-wrap  requires content to have no new lines, reason for adding eslint-disable !-->
    <template v-else>{{ text === null || text.length === 0 ? defaultEmptyText : text }}</template><!-- pre-wrap  requires content to have no new lines, reason for adding eslint-disable !-->
  </div><!-- pre-wrap  requires content to have no new lines, reason for adding eslint-disable !-->
  <!-- eslint-enable -->
</template>

<script>
/**
 * Div that displays a text
 *  - Truncates when exceeding maxChars, adding ellipsis to the end (included within maxChars)
 *  - Sizes div with minWidth and maxWidth
 *  - Won't truncate based on maxWidth because:
 *    - text alignment is displayed wrong, complex styling issue
 *    - the tooltip can not be shown easily this way
 *    - would require manual calculation of the div bounds, which may be costly
 */
import _truncate from 'lodash/truncate'
export default {
  name: 'VTextBox',
  props: {
    /**
     * Text to display
     */
    text: {
      required: false,
      type: [String, Number],
      default: '',
    },
    /**
     * Maximum characters to truncate text to, and show ellipsis
     * Ellipsis (default 3 characters ...) are included in this max
     */
    maxChars: {
      required: false,
      type: Number,
      default: undefined,
    },
    maxLines: {
      required: false,
      type: Number,
      default: 3,
    },
    /**
     * if maxChars is not given, these options can be given for the lodash truncate function
     */
    options: {
      required: false,
      type: Object,
      default: () => {},
    },
    /**
     * Minimal width the div must assume
     * When text is longer than minWidth, this attribute is ignored and the div expand to text length
     */
    minWidth: {
      required: false,
      type: String,
      default: undefined,
    },
    /**
     * Maximum width the div must assume
     * When text overflows, this attribute is ignored and the div expands to text length
     */
    maxWidth: {
      required: false,
      type: String,
      default: undefined,
    },
    /**
     * How text may be wrapped
     */
    whiteSpaceWrap: {
      required: false,
      type: String,
      default: 'pre-wrap',
    },
    /**
     * How words may be broken
     * Otherwise, text wrapping will give precedence to white spaces
     */
    wordBreak: {
      required: false,
      type: String,
      default: 'normal',
    },
    defaultEmptyText: {
      required: false,
      type: String,
      default: '',
    },
  },
  computed: {
    clampStyle () {
      return {
        'white-space': this.whiteSpaceWrap,
        display: '-webkit-inline-box',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        'line-clamp': this.maxLines,
        '-webkit-line-clamp': this.maxLines,
        'word-break': this.wordBreak,
      }
    },
    sizeStyle () {
      const styleObject = {}
      if (this.minWidth) {
        styleObject['min-width'] = this.minWidth
        if (this.maxWidth === undefined || this.minWidth <= this.maxWidth) {
          styleObject.width = this.minWidth
        }
      }
      if (this.maxWidth) {
        styleObject['max-width'] = this.maxWidth
        if (this.minWidth !== undefined && this.minWidth > this.maxWidth) {
          styleObject.width = this.maxWidth
        }
      }
      return styleObject
    },
  },
  methods: {
    truncateText (text) {
      const options = this.maxChars ? { length: this.maxChars, separator: '' } : this.options
      return _truncate(text, options)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip .tooltip-inner {
  max-width: 400px;
}
.vtextbox {
  margin-bottom: -8px;
}
.cursor-help {
  cursor: help;
}
</style>
